export default __webpack_public_path__ + "static/media/Hamburger.dc1bb905.svg";